import React from 'react';

import StockShowMoreButton from '@/components/StockShowMoreButton';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getShowMoreParams,
  setShowMoreParams,
} from '@/store/reducers/cars-stock';
import { StockShowMoreButtonWrapper } from '@/modules/CarsStock/components/common.styles';

function AllParamsButton() {
  const dispatch = useTypedDispatch();
  const isShowMoreParams = useTypedSelector(getShowMoreParams);

  const handleButtonClick = () => {
    dispatch(setShowMoreParams(!isShowMoreParams));
  };

  return (
    <StockShowMoreButtonWrapper>
      <StockShowMoreButton
        label={`${!isShowMoreParams ? 'Все параметры' : 'Показать меньше'}`}
        onClick={handleButtonClick}
      />
    </StockShowMoreButtonWrapper>
  );
}

export default AllParamsButton;
